// extracted by mini-css-extract-plugin
export default {"link":"BackLink_link__OsH+i"};